<template>
  <div class="AllPwaMobile currentService">
    <div class="ShowSnackbarClickDiv">
      <div class="ChildHightMap">
        <div id="search_map"></div>

        <NeshanMap
          :default-type="isDarkMode == true ? 'standard-night' : 'neshan'"
          ref="myMap"
          :key="reloadKey"
          :mapKey="taxi_c_set.map_info.map_key"
          :serviceKey="service_api"
          :zoom="14"
          :poi="true"
          :traffic="true"
          :hide-search-container="true"
          :center="{ latitude: 36.311559, longitude: 59.5870851 }"
          @on-init="getmounted"
          :reverse-on-click="false"
          hide-layers
        />
      </div>
      <div v-show="StatusEn == 'waiting_customer'" class="driverArrivedMessage">
        راننده به مبدا رسیده است
      </div>
      <section class="sectionClassItemDiv contentContainer">
        <div class="contentHeader">
          <div class="hedaerDriverInfo">
            <div class="infoContent">
              <div class="contentPic">
                <img
                  v-if="!service_data.avatar"
                  src="@/assets/images/avatar.png"
                />
                <img v-if="service_data.avatar" :src="service_data.avatar" />
              </div>
              <div class="contentDetails">
                <div class="detailsTitle">{{ service_data.driver_name }}</div>
                <div class="detailsSubtitle">
                  <img src="@/assets/images/icons/car.svg" alt="" />
                  <span class="subtitleContent"
                    >{{ service_data.car_name }}
                    {{ service_data.car_color }}</span
                  >
                </div>
              </div>
            </div>
            <div class="infoOption">
              <div class="optionCallBtn" @click="secureCall()">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="size-6"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="hedaerCarInfo">
            <div class="serviceStatus">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="size-6"
              >
                <path
                  fill-rule="evenodd"
                  d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                  clip-rule="evenodd"
                />
              </svg>
              <span>تایید راننده</span>
            </div>
            <div
              v-if="plaque[0]"
              style="direction: rtl"
              class="PluckShowDirection"
            >
              <div class="ShowSpanStyleA">
                <div>ایران</div>
                <div>{{ plaque[0] }}</div>
              </div>

              <div class="ShowSpanStyleZ">
                <span>{{ plaque[1] }}</span>
                <span class="mr-2">{{ plaque[2] }}</span>
                <span class="mr-2">{{ plaque[3] }}</span>
              </div>

              <div class="ShowAssetsClassIr">
                <img src="@/assets/images/iran_flag.png" alt="iran" />
                <div class="mt-1 irPlate">I.R.</div>
                <div class="isMiniPlate" style="font-size: 5px">IRAN</div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="CurrentRow2">
          <div class="plaque" >

          </div>
          <div class="plaque" v-if="!plaque[0]">
            <div style="width: 100%; height: 4px; background-color: lightgray; animation: indeterminate 1.5s infinite;">
            </div>
          </div>

          <div class="ClassShowButtonAndTextDFlex">
            <span>تایید راننده</span>
              <VsxIcon :size="28" color="#1287A5" type="linear" />
            <VsxIcon iconName="Check" :size="28" color="#1287A5" type="linear" />
          </div>
        </div> -->

        <div class="detailsInfo">
          <div class="infoThumbWrapper">
            <div class="detailsInfoThumb">
              <p>زمان رسیدن راننده :</p>
              <p>{{ distance_far }} دقیقه</p>
            </div>
            <div class="detailsInfoThumb">
              <p>هزینه سفر:</p>
              <p>{{ formatPrice(service_data.amount) }} تومان</p>
            </div>
          </div>
          <div class="infoButtons">
            <div
              class="infoBtn"
              @click="this.$refs.chat.open(), (ismsg = true)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="size-6"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.848 2.771A49.144 49.144 0 0 1 12 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97a48.901 48.901 0 0 1-3.476.383.39.39 0 0 0-.297.17l-2.755 4.133a.75.75 0 0 1-1.248 0l-2.755-4.133a.39.39 0 0 0-.297-.17 48.9 48.9 0 0 1-3.476-.384c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97ZM6.75 8.25a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H7.5Z"
                  clip-rule="evenodd"
                />
              </svg>
              <span>چت</span>
            </div>
            <div class="infoBtn" @click="travel_detail">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="size-6"
              >
                <path
                  fill-rule="evenodd"
                  d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                  clip-rule="evenodd"
                />
              </svg>

              <span>جزئیات</span>
            </div>
          </div>

          <button class="cancleService" @click="cancel_trip_btn('t')">
            لغو سفر
          </button>
        </div>
      </section>
    </div>

    <vue-bottom-sheet
      ref="issheet1"
      style="z-index: 1050"
      v-model="issheet"
      persistent
    >
      <div style="height: 462px">
        <service_page
          v-if="issheet"
          :service_data="service_data"
          @creadit_pay="creadit_pay()"
          @close="travel_detail()"
        />
      </div>
    </vue-bottom-sheet>
    <vue-bottom-sheet
      :can-swipe="false"
      ref="issheet_credit1"
      style="z-index: 1050"
      v-model="issheet_credit"
    >
      <div style="height: 712px">
        <credit :inservice="true" @close="creadit_pay()" />
      </div>
    </vue-bottom-sheet>
    <vue-bottom-sheet ref="iscancel1" style="z-index: 1050" v-model="iscancel">
      <div @click="close_modal()" class="TopStyleShowToUser"></div>
      <div>
        <div>
          <div @click="cancel_trip_btn('f')"></div>
        </div>

        <div class="allShowToCancelToUs cancelPopup">
          <div class="cancleServiceHeader">
            <div class="headerIcon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                <path
                  d="M352 96C352 78.3 337.7 64 320 64C302.3 64 288 78.3 288 96L288 416C288 433.7 302.3 448 320 448C337.7 448 352 433.7 352 416L352 96zM320 576C342.1 576 360 558.1 360 536C360 513.9 342.1 496 320 496C297.9 496 280 513.9 280 536C280 558.1 297.9 576 320 576z"
                />
              </svg>
            </div>
            <div class="headerTitle">آیا از لغو این سرویس مطمئن هستید؟</div>
          </div>
          <div class="cancleReasons">
            <div class="reasonsContainer">
              <div
                @click="GetValueShow(templates)"
                v-for="(templates, index) in cancel_s_defult"
                :key="index"
                class="containerThumb"
              >
                {{ templates }}
              </div>
            </div>
          </div>

          <!-- <PerfectScrollbar class="ShowOfferToMe">
            <div @click="GetValueShow(templates)" v-for="(templates, index) in cancel_s_defult" :key="index"
              class="ChildShowOfferToMe">
              {{ templates }}
            </div>
          </PerfectScrollbar> -->

          <input
            class="cancelReasonInput"
            placeholder="دلیل رد سرویس را وارد کنید"
            v-model="description"
          />

          <div class="cancelActionsButtons">
            <div v-if="!loading" class="actionBtn" @click="cancel_trip">
              لغو سرویس
            </div>
            <div v-if="loading" class="actionBtn">
              <div class="whiteLoader"></div>
            </div>
            <div class="actionBtn cancelBtn" @click="cancel_trip_btn('f')">
              انصراف
            </div>
          </div>
        </div>
      </div>
    </vue-bottom-sheet>
    <vue-bottom-sheet
      ref="chat"
      :overlay-click-close="false"
      :can-swipe="false"
      style="z-index: 1050"
    >
      <div style="height: 500px">
        <div
          @click="closeMessage()"
          style="background: transparent; top: 10px !important"
          class="closeServiceList"
        >
          <VsxIcon iconName="CloseSquare" :size="35" color="red" type="bold" />
        </div>
        <MessageUser
          ref="child"
          v-if="ismsg"
          :ServiceData="ServiceData"
          :key="messageKey"
        ></MessageUser>
      </div>
    </vue-bottom-sheet>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import "@webzlodimir/vue-bottom-sheet/dist/style.css";
// import { toast } from 'vue3-toastify';
// import 'vue3-toastify/dist/index.css';
import NeshanMap from "@neshan-maps-platform/vue3-openlayers";
import { fromLonLat } from "@neshan-maps-platform/ol/proj";
import Feature from "@neshan-maps-platform/ol/Feature";
import Point from "@neshan-maps-platform/ol/geom/Point";
import VectorSource from "@neshan-maps-platform/ol/source/Vector";
import VectorLayer from "@neshan-maps-platform/ol/layer/Vector";
import { Style, Icon } from "@neshan-maps-platform/ol/style";
import service_page from "@/components/taxi/service_page";
import credit from "@/components/taxi/creditUser";
// import 'ol/ol.css';
import MessageUser from "@/components/taxi/MessageUser";
import { toast } from "vue3-toastify";
import carIcon from "@/assets/img/car.png";
import Iconmarker1 from "@/assets/img/marker1.png";
import Iconmarker2 from "@/assets/img/marker2.png";
import Iconmarker3 from "@/assets/img/marker3.png";
export default {
  name: "currentService",
  components: {
    // PerfectScrollbar,
    VueBottomSheet,
    NeshanMap,
    service_page,
    MessageUser,
    credit,
  },
  props: {
    StatusEn: String,
    ChatOpen: Boolean,
    ServiceData: Object,
    DriverLocation: Object,
  },
  watch: {
    DriverLocation: {
      handler(newVal) {
        console.log("DriverLocation updated:", newVal);
        this.driver_distance_origin(newVal);
        this.updateVehiclePosition(newVal.lat, newVal.lng);
      },
      deep: true,
      immediate: true,
    },
    ChatOpen: {
      handler(newVal) {
        if (newVal) {
          this.chatCounter++;
          this.ChatOpen1 = newVal;
          console.log(newVal);
          this.$nextTick(() => {
            if (this.$refs.chat) {
              this.$refs.chat.open();
              this.ismsg = true;
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
    ServiceData: {
      handler(newVal) {
        console.log("ServiceData:" + newVal);
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_PUBLIC_PATH,
      currentIndex: 0,
      updateInterval: null,
      vehicleMarker: null,
      isDarkMode: false,
      messageKey: 0,
      e6: 1,
      cancel_s_defult: [],
      dropArea: null,
      list: [],
      issheet: false,
      issheet_credit: false,
      issheet_sharing: false,
      audioSrc: "/app/media/service.86ffa798.mp3",
      playing: false,
      file_list: [],
      loading: false,
      items_subcategory: [],
      items_state: [],
      items_city: [],
      param: {
        content: "",
        latitude: "",
        longitude: "",
        category: null,
        sub_category: null,
        main_category: null,
        meter_price: null,
        mortgage_price: null,
        rent_price: null,
        total_price: null,
        building_area: null,
        land_area: null,
        floor: null,
        state: null,
        city: null,
        address: null,
        comment_status: null,
        owner_name: "",
        search_address: null,
        contact: "",
        details: null,
      },
      lat: 35.688428639754235,
      lng: 51.38988018035889,
      map: null,
      marker_add: 0,
      marker1: null,
      time: "",
      newservice_data: [],
      iscancel: false,
      text: "",
      service_status: "",
      description: "",
      StatusEn1: "",
      prevCoords: "",
      reloadKey: 0,
      plaque: [],
      service_data: [],
      orgin_point: null,
      destination_point: null,
      destination_point2: null,
      driver_point: null,
      lattest: "",
      lngtest: "",
      distance_far: 0,
      service_api: "",
      step_load: 0,
      ismsg: false,
      chatCounter: 0,
      ChatOpen1: false,
      markericon: [],
    };
  },

  computed: {
    ...mapGetters(["auth_taxi", "taxi_c_set"]),
  },

  mounted() {
    let self = this;
    self.markericon[0] = Iconmarker1;
    self.markericon[1] = Iconmarker2;
    self.markericon[2] = Iconmarker3;

    self.check_currentservice();

    console.log("this.taxi_c_set", this.taxi_c_set);

    this.cancel_s_defult = this.taxi_c_set.cancel_s_defult;
    this.StatusEn1 = this.StatusEn;
    this.ChatOpen1 = this.ChatOpen;
    setTimeout(function () {
      self.dropArea = document.getElementById("drop-area");
    }, 1000);
    setInterval(() => {
      this.loadTheme();
    }, 100);
  },

  methods: {
    closeMessage() {
      this.$refs.chat.close();
      this.$refs.child.clearMethod();
      this.messageKey += 1;
      this.ismsg = false;
    },
    updateVehiclePosition(lat, lng) {
      // let self = this;
      try {
        if (!this.map) {
          console.error("Map is not initialized.");
          return;
        }

        const fixedLat = lat;
        const fixedLng = lng;

        const coordinates = fromLonLat([fixedLng, fixedLat]);

        console.log("coordinates", coordinates);
        let heading = 0;
        if (this.prevCoords) {
          const [prevLng, prevLat] = this.prevCoords;
          const deltaLng = fixedLng - prevLng;
          const deltaLat = fixedLat - prevLat;
          heading = Math.atan2(deltaLng, deltaLat);
        }

        if (this.vehicleMarker && this.map) {
          this.map.removeLayer(this.vehicleMarker);
          this.vehicleMarker.dispose();
          this.vehicleMarker = null;
        }

        const marker = new Feature({
          geometry: new Point(coordinates),
        });

        const iconStyle = new Style({
          image: new Icon({
            src: carIcon,
            scale: 0.5,
            rotation: heading,
          }),
        });

        marker.setStyle(iconStyle);

        const vectorSource = new VectorSource({
          features: [marker],
        });

        this.vehicleMarker = new VectorLayer({
          source: vectorSource,
        });

        this.map.addLayer(this.vehicleMarker);
        this.map.getView().setCenter(coordinates);
        this.map.getView().setZoom(17);

        this.prevCoords = [fixedLng, fixedLat];
      } catch (error) {
        console.error("Error updating vehicle position:", error);
      }
    },

    loadTheme() {
      const savedTheme = localStorage.getItem("theme");

      if (this.savedTheme1 !== savedTheme) {
        this.savedTheme1 = savedTheme;

        if (savedTheme == "light") {
          this.isDarkMode = false;
        } else {
          this.isDarkMode = true;
        }
        this.reloadKey += 1;
      }
    },
    getmounted(map) {
      let self = this;
      self.step_load += 1;
      console.log(
        "self.taxi_c_set.map_info.map_service",
        self.taxi_c_set?.map_info?.map_service
      );
      if (
        self.taxi_c_set.map_info.map_key != "" &&
        self.taxi_c_set.map_info.map_service != ""
      ) {
        self.NeshanMapLoad = true;
        self.service_api = self.taxi_c_set.map_info.map_service;
      }

      const dataB = self.ServiceData;
      self.list[0] = dataB.origin;
      self.list[1] = dataB.destination_arr;
      self.list[2] = dataB.second_destination_arr;
      self.map = map;

      if (self.step_load >= 2) {
        //بدلیل 2 بار لواد شدن نقشه برای این فانکشن محدودیت گذاشته شد
        self.initializeMap(map, dataB);
      }
    },
    GetValueShow(value) {
      this.description = value;
    },

    calculateDistance(coord1, coord2, R = 6371e3) {
      //R => پیش فرض شعاع زمین به متر هست
      const lat1 = (coord1[0] * Math.PI) / 180;
      const lon1 = (coord1[1] * Math.PI) / 180;
      const lat2 = (coord1[0] * Math.PI) / 180;
      const lon2 = (coord2[1] * Math.PI) / 180;

      const deltaLat = lat2 - lat1;
      const deltaLon = lon2 - lon1;

      const a =
        Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
        Math.cos(lat1) *
          Math.cos(lat2) *
          Math.sin(deltaLon / 2) *
          Math.sin(deltaLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      return R * c; // فاصله به متر/کیلومتر (بسته به مقدار R )
    },
    getZoomLevelFromDistance(distance) {
      if (distance * 1000 < 500) return 17; // فاصله کمتر از 500 متر
      if (distance * 1000 < 2000) return 15; // فاصله کمتر از 2 کیلومتر
      if (distance * 1000 < 5000) return 14; // فاصله کمتر از 5 کیلومتر
      return 12; // فاصله بیشتر از 5 کیلومتر
    },

    calculateTravelTime(distance, speed) {
      const timeInHours = distance / speed; // زمان به ساعت
      const timeInMinutes = timeInHours * 60; // زمان به دقیقه
      return timeInMinutes;
    },

    async initializeMap(map, value) {
      const view = map.getView();
      const marker1 = [value.origin.lat, value.origin.lng];
      const marker2 = [value.destination_arr.lat, value.destination_arr.lng];
      const marker3 = [
        value.second_destination_arr.lat,
        value.second_destination_arr.lng,
      ];
      const CalcNeshanNoTraffic = await this.CalcNeshanNoTraffic(
        marker1,
        marker2,
        marker3
      );
      const zoomLevel = this.getZoomLevelFromDistance(
        CalcNeshanNoTraffic.Distance
      );
      view.animate({
        center: fromLonLat([value.destination_arr.lng, value.origin.lat]),
        zoom: zoomLevel,
        duration: 100,
      });
      this.mapAction(map);
    },
    async driver_distance_origin() {
      let self = this;
      console.log("self.service_data", self.service_data);

      const origin_location = [
        self.service_data?.origin?.lat,
        self.service_data?.origin?.lng,
      ];
      const driver_location = [
        self.DriverLocation.lat,
        self.DriverLocation.lng,
      ];
      const CalcNeshanNoTraffic = await self.CalcNeshanNoTraffic(
        driver_location,
        origin_location,
        []
      );
      console.log(CalcNeshanNoTraffic);
      this.distance_far = CalcNeshanNoTraffic.Duration;
    },
    async secureCall() {
      let self = this;
      if (this.taxi_c_set.secure_call == "enable") {
        let newParam = {};
        newParam =
          "&uid=" +
          this.auth_taxi.uid +
          "&caller=" +
          this.auth_taxi.mobile +
          "&callee=" +
          this.service_data.driver_mobile;
        self
          .helperGet_taxi("secure-call", newParam)
          .then(function (r) {
            if (r.data.Response === "Success") {
              (this.CallDisable = false),
                toast.success("تماس امن برقرار شد منتظر بمانید");
            } else {
              (this.CallDisable = false),
                (window.location.href = `tel:${this.service_data.driver_mobile}`);
            }
          })
          .catch(function () {
            self.loading = false;
          });
      } else {
        (this.CallDisable = false),
          (window.location.href = `tel:${this.service_data.driver_mobile}`);
      }
    },
    async CalcNeshanNoTraffic(origin, destination, destination2) {
      this.loadingPrice = true;
      var parameter = "?type=car&origin=" + origin[0] + "," + origin[1];
      if (destination2[0] != null) {
        parameter +=
          "&waypoints=" +
          destination[0] +
          "," +
          destination[1] +
          "&destination=" +
          destination2[0] +
          "," +
          destination2[1];
      } else {
        parameter += "&destination=" + destination[0] + "," + destination[1];
      }

      let responseNoTraffic = await fetch(
        "https://api.neshan.org/v4/direction/no-traffic" + parameter,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Api-Key": this.service_api,
          },
        }
      );

      let json = await responseNoTraffic.json();
      console.log("responseNoTraffic", json);
      this.noTrafficDuration = Math.round(
        json.routes[0].legs[0].duration.value / 60
      );
      var legs = json.routes[0].legs;
      var nDirection_distance = 0;
      var dDirection_duration = 0;
      for (var i = 0; i < legs?.length; i++) {
        nDirection_distance += parseFloat(legs[i].distance.value);
        dDirection_duration += parseFloat(legs[i].duration.value);
      }
      // console.log('nDirection_distance',nDirection_distance)
      var Distance = Math.round(
        Number(parseFloat(nDirection_distance / 1000)).toFixed(1)
      );
      var Duration = Number(parseFloat(dDirection_duration / 60)).toFixed(0);
      //--------------------------------------------------------------------------
      //Exchange Operations
      var Distance2 = 0;
      var Duration2 = 0;

      var TotalDistance = parseFloat(Distance) + parseFloat(Distance2);
      var TotalDuration = parseFloat(Duration) + parseFloat(Duration2);

      var result = {
        Distance: TotalDistance,
        Duration: TotalDuration,
      };
      return result;
    },
    mapAction(map) {
      let self = this;
      this.marker_add = 0;

      if (this.marker_add === 0) {
        if (self.list.length > 0) {
          self.list.forEach((value, index) => {
            if (index < 3 && value.lat && value.lng) {
              const marker = new Feature({
                geometry: new Point(fromLonLat([value.lng, value.lat])),
              });

              // const imageUrl =  Iconmarker + (index + 1) + '.png'; // مسیر تصویر را تنظیم کنید

              const iconStyle = new Style({
                image: new Icon({
                  src: self.markericon[index],
                  scale: 0.8,
                }),
              });

              marker.setStyle(iconStyle);

              const vectorSource = new VectorSource({
                features: [marker],
              });

              const markerLayer = new VectorLayer({
                source: vectorSource,
              });

              map.addLayer(markerLayer);
            }
          });
          this.marker_add = 1;
        }
      }
    },

    check_currentservice() {
      let self = this;
      console.log(";self;self", self.ServiceData);
      self.service_data = self.ServiceData;
      self.lat = self.service_data.destination_arr.lat;
      self.lng = self.service_data.destination_arr.lng;
      console.log("new_status:" + self.service_data.status);
      self.StatusEn1 = self.service_data.status;
      self.set_plaque();
    },
    set_plaque() {
      let plaque = this.service_data.plaque.split("|");
      this.plaque[0] = plaque[0];
      this.plaque[1] = plaque[1];
      this.plaque[2] = plaque[2];
      this.plaque[3] = plaque[3];
    },
    cancel_trip_btn(mode) {
      if (mode === "t") {
        this.iscancel = true;
        this.$refs.iscancel1.open();
      } else {
        this.iscancel = false;
        this.$refs.iscancel1.close();
      }
    },
    cancel_trip() {
      let self = this;
      this.loading = true;
      this.helperPost_taxi("customer-cancel-service", {
        service_id: this.service_data.service_id,
        uid: this.auth_taxi.uid,
      })
        .then((r) => {
          if (r.data.result == "1") {
            toast(r.data.msg, {
              autoClose: 3000,
              position: "top-right",
              type: "success",
            });

            setTimeout(function () {
              self.$router.push({ path: "/taxi/manualService" });
            }, 1000);
          } else if (r.data.result == "0") {
            toast(r.data.msg, {
              autoClose: 3000,
              position: "top-right",
              type: "error",
            });
          } else {
            toast(r.data.msg, {
              autoClose: 3000,
              position: "top-right",
              type: "error",
            });
          }
          this.loading = false;
        })
        .catch(function () {
          self.loading = false;
        });
    },
    masiryabi() {
      // let self=this;
      // self.issheet=true
    },
    travel_detail() {
      this.issheet = false;
      this.issheet = !this.issheet;
      this.$refs.issheet1.open();
      // console.log("this.$refs.issheet1.open", this.$refs.issheet1);
    },
    close_modal() {
      this.iscancel = false;
      this.iscancel = !this.iscancel;
      this.$refs.iscancel1.open();
    },
    creadit_pay() {
      this.issheet = !this.issheet;
      this.issheet_credit = !this.issheet_credit;
      this.$refs.issheet1.close();
      this.$refs.issheet_credit1.open();
    },
    openChat() {
      this.ChatOpen1 = false; // ابتدا false می‌شود
      setTimeout(() => {
        this.ChatOpen1 = true; // سپس true می‌شود
      }, 0);
    },
  },
};
</script>

<style scoped lang="scss">
.ps__rail-x {
  display: none !important;
}

.cancleService {
  width: 100%;
  height: 50px;
  border-radius: 10px;
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
  background: #ef4444;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  margin-top: 24px;
}

.detailsThumbBtn {
  width: 100%;
  height: 42.4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-family: "iranyekanB", sans-serif;
  font-size: 0.8rem;
  color: #fff;
  cursor: pointer;
  background: #0851a0;
  border-radius: 10px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);

  svg {
    width: 18px;
    height: 18px;
  }
}

.detailsInfo {
  width: 100%;
  padding: 0 18px;
}

.detailsInfoThumb {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f7f7f7 !important;
  border-radius: 10px !important;
  border: 1px solid #dedede !important;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15) !important;
  padding: 12px;
  color: #000;
  font-size: 0.9rem;
  direction: rtl;
  margin-bottom: 16px;

  p {
    &:first-child {
      font-size: 0.85rem;
    }

    &:last-child {
      font-family: "iranyekanB", sans-serif;
      font-size: 0.9rem;
    }
  }
}

.infoButtons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  .infoBtn {
    direction: rtl;
    width: 100%;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    background: #0851a0;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
    font-family: "iranyekanB", sans-serif;
    font-size: 0.85rem;
    color: #fff;
    border-radius: 10px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
}

.ChildHightMap {
  height: calc(100vh - 468px) !important;
}

.driverArrivedMessage {
  width: 100%;
  padding: 16px 0 32px;
  text-align: center;
  font-family: "iranyekanB", sans-serif;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2066d3;
  position: absolute;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 468px;
  color: #fff;
}

.currentService {
  width: 100%;
  height: 100vh;
  position: relative;
}

.sectionClassItemDiv {
  &.contentContainer {
    margin-top: -16px !important;
    border-top-left-radius: 16px !important;
    border-top-right-radius: 16px !important;
    box-shadow: 1px -2px 4px 4px rgba(0, 0, 0, 0.15) !important;
    width: 100%;
    position: relative;
    z-index: 1;
    background: #fff;
    padding: 28px 0 24px;

    .contentHeader {
      width: calc(100% - 32px);
      margin-left: auto;
      margin-right: auto;
      padding: 16px;
      box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1),
        0 2px 4px -2px rgb(0 0 0 / 0.1);
      border-radius: 10px;
      background: #fff;
      direction: rtl;
      margin-bottom: 24px;

      .hedaerDriverInfo {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;

        .infoContent {
          display: flex;
          align-items: center;
          gap: 12px;
          color: #000;

          .contentPic {
            width: 58px;
            height: 58px;
            border-radius: 50%;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .contentDetails {
            .detailsTitle {
              font-family: "iranyekanB", sans-serif;
              font-size: 0.95rem;
              margin-bottom: 4px;
            }

            .detailsSubtitle {
              display: flex;
              align-items: center;
              gap: 6px;

              img {
                width: 20px;
                height: 20px;
              }

              .subtitleContent {
                font-size: 0.85rem;
              }
            }
          }
        }

        .infoOption {
          .optionCallBtn {
            width: 44px;
            height: 44px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            background: #0851a0;
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);

            svg {
              width: 28px;
              height: 28px;
            }
          }
        }
      }

      .hedaerCarInfo {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .serviceStatus {
          padding: 8px 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
          color: #0851a0;
          font-size: 0.85rem;
          background: rgba(52, 190, 115, 0.1);
          border-radius: 10px;

          svg {
            width: 20px;
            height: 20px;
          }
        }

        .PluckShowDirection {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-radius: 5px !important;
          width: 192px;
          overflow: hidden;
          background: #f9fafb;
          border: 1px solid #dedede;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
          height: 50px !important;

          .ShowSpanStyleA {
            gap: 0px;
            color: #333;
            font-size: 13px;
            border-left: 1px solid #ececec;
            padding: 0px 9px;
            font-family: "iranyekanB";
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            & > div {
              margin-top: -4px;
            }
          }

          .ShowSpanStyleZ {
            display: flex;
            align-items: center;
            gap: 10px;

            span {
              color: #333;
              font-size: 1.2rem;
              font-family: "iranyekanB";
            }
          }

          .ShowAssetsClassIr {
            height: 100%;
            background: blue;
            text-align: left;
            width: 32px;
            display: flex;
            flex-direction: column;
            padding: 8px 4px 4px;

            img {
              width: 80%;
              height: auto;
              border-radius: 2px;
              margin-right: auto;
              margin-left: 0;
            }

            .irPlate {
              font-size: 0.55rem;
              text-align: left;
            }

            .isMiniPlate {
              font-size: 5px;
              margin-top: -3px;
              text-align: left;
            }
          }
        }
      }
    }
  }
}

.cancleServiceHeader {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 8px;

  .headerIcon {
    width: 72px;
    height: 72px;
    background: rgb(254 226 226 / 1);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;

    svg {
      width: 32px;
      height: 32px;
      fill: #f00;
    }
  }

  .headerTitle {
    text-align: center;
    font-family: "iranyekanB", sans-serif;
    font-size: 1.05rem;
    color: #000;
  }
}

.cancleReasons {
  width: 100%;
  overflow: hidden;
  margin: 24px 0;
  direction: rtl;

  .reasonsContainer {
    overflow-x: auto;
    scrollbar-width: none;
    display: flex;
    align-items: center;
    gap: 16px;

    &::-webkit-scrollbar {
      display: none;
    }

    .containerThumb {
      padding: 8px 16px;
      background: rgba(8, 81, 160, 0.15) !important;
      color: #0851a0 !important;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 9999px;
      cursor: pointer;
      transition: all 0.1s;
      white-space: nowrap;

      &:active {
        transform: scale(0.95);
      }

      &:first-child {
        margin-right: 18px;
      }

      &:last-child {
        margin-left: 18px;
      }
    }
  }
}

.cancelReasonInput {
  width: 90%;
  background: transparent;
  border-radius: 9999px;
  padding: 12px 16px;
  font-size: 0.9rem;
  transition: all 0.25s;
  text-align: right;
  direction: rtl;
  height: 44px !important;
  border-radius: 10px !important;
  background: #f7f7f7;
  border: 1px solid #dedede !important;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15) !important;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 24px;
  display: block;

  &:focus {
    background: #fff;
  }
}

.allShowToCancelToUs {
  &.cancelPopup {
    padding: 0 !important;
  }
}

.cancelActionsButtons {
  direction: rtl;
  padding-bottom: 24px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  .actionBtn {
    direction: rtl;
    width: 100%;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    background: #0851a0;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
    font-family: "iranyekanB", sans-serif;
    font-size: 0.95rem;
    color: #fff;
    border-radius: 10px;

    &.cancelBtn {
      background: #ef4444 !important;
    }

    svg {
      width: 20px;
      height: 20px;
    }
  }
}

.callDriverBtn {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0851a0;
  box-shadow: 0;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  border-radius: 10px;
}

:deep(.ol-viewport) {
  & > div {
    &:last-child {
      display: none !important;
    }
  }
}
</style>
